import { ADMIN_REPORT_DOWNLOAD_PATH } from 'utils/constants/api'
import { useDocumentFetcher } from './useDocumentFetcher'

const { REACT_APP_API_HOST = '' } = process.env

const useAdminReport = () => {
  const URL = `${REACT_APP_API_HOST}${ADMIN_REPORT_DOWNLOAD_PATH}`
  const { fetchDocument, reset, loading, error, data } = useDocumentFetcher()

  const getReport = async (hashId: string, name: string) => {
    const url = `${URL}/${hashId}`
    await fetchDocument({ url, name: name || '' })
  }

  return { getReport, reset, loading, error, data }
}

export { useAdminReport }
